//slick
$(document).ready(function () {
    if($().slick) {
        $(".lime-carousel-3-slides").slick({//3 slides in DT
            infinite: true,
            dots: true,
            slidesToShow: 3,
            speed: 1000,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
        $(".lime-carousel-2-slides").slick({//Shopping cart carousel for 2 slides
            infinite: true,
            dots: true,
            slidesToShow: 2,
            speed: 1000,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    } else {
        $('.carousel-wrapper').remove();
    }
});
